

import { Company } from "@panel/company";
import { Role } from "./role.model";

export class User {
  id: number;
  username: string;
  idRole: number;
  email: string;
  firstName: string;
  lastName: string;
  mobilePhone?: string;
  telephone: string;
  idCompany?: number;
  idCompanyOrigin?: number;
  role?: Role;
  operator?: Company;
  company?: Company;
  companyOrigin?: Company;
  token: string;
  modules: [{idModule: number}];
  informationClauseAccepted: boolean;
  activated: boolean;
  refreshToken?: string;
  status: string;
  disabledModules?: any[] = [];
  disclaimerAccepted?: boolean;
}

export class UserRole {
  id: number;
  name: string;
  weight: number;
}

export class NewUser {
  id: number;
  email: string;
  firstName: string;
  lastName: string;
  telephone?: string;
  mobilePhone?: string;
  idRole: number;
  idCompany?: number;
  role?: Role;
  status?: string;
}

export interface UserChangeCompany {
  idCompany: number;
}

export interface UserQueryParams {
  selectLimit?: number;
  idCompany?: number;
  getCompanyUsers?: boolean;
  assignedCompanies?: boolean;
}

